import * as lineitems from 'smg/customer-api/lineitems';
import { DollarFormat } from 'smg/util';

// <div class="bg-light border mt-2 p-2 rounded"><span class="pricing-child-option" data-line-item="challenge coin" data-child="edge" data-option="Oblique"></span></div>

document.querySelectorAll('.pricing-child-option').forEach(async $pricingChildOption => {
    const lineItem = $pricingChildOption.getAttribute('data-line-item');
    const child = $pricingChildOption.getAttribute('data-child');
    const option = $pricingChildOption.getAttribute('data-option');

    if (!lineItem || !child || !option) {
        return;
    }

    await lineitems.GetOptions(lineItem, child).then(options => {
        const $option = options.find(o => o.name === option);
        if ($option) {
            let existingText = $pricingChildOption.textContent;
            if (existingText && existingText.length > 0) {
                existingText = ' ' + existingText;
            } else {
                existingText = '';
            }
            if ($option.price?.gt(0)) {
                $pricingChildOption.textContent = DollarFormat($option.price) + existingText;
            } else {
                $pricingChildOption.textContent = 'Included';
            }
        }
    });
});
